(function () {
  function start(root) {
    if (!root || root.dataset.running) return;
    root.dataset.running = 'yes';
    const slides = Array.from(root.querySelectorAll('.campaign-slide'));
    const frame = root.querySelector('.slide-frame');
    const caption = root.querySelector('.hero-caption');
    const control = root.querySelector('[data-rotation]');
    if (slides.length < 2 || !frame || !caption || !control) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = motion.matches;
    let index = 0, timer, touch;
    function change(step) {
      index = (index + step + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      caption.href = slides[index].dataset.link;
      caption.textContent = slides[index].dataset.label.replace(/\s*↗\uFE0E?/g, '');
    }
    function schedule() {
      clearInterval(timer);
      control.textContent = paused ? '▶' : 'Ⅱ';
      control.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      if (!paused && !document.hidden) timer = setInterval(() => change(1), 6500);
    }
    control.onclick = () => { paused = !paused; schedule(); };
    frame.addEventListener('touchstart', e => { touch = e.touches[0]; }, {passive:true});
    frame.addEventListener('touchend', e => {
      if (!touch) return;
      const x = e.changedTouches[0].clientX - touch.clientX;
      const y = e.changedTouches[0].clientY - touch.clientY;
      if (Math.abs(x) > 40 && Math.abs(x) > Math.abs(y)) { change(x < 0 ? 1 : -1); schedule(); }
      touch = null;
    }, {passive:true});
    document.addEventListener('visibilitychange', schedule);
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      clearInterval(timer); document.removeEventListener('visibilitychange', schedule);
    }, {once:true});
    schedule();
  }
  document.querySelectorAll('.rb-home .carousel').forEach(start);
  document.addEventListener('shopify:section:load', e => start(e.target.querySelector('.rb-home .carousel')));
})();